<template>
    <div class="container min-width-content">
        <template>
            <div class="card card-box">
                <div class="card-body card-bg text-center">
                    <h3 class="font-weight-bold py-2">{{ successCount }} data BERHASIL diupload!</h3>
                    <h3 class="failed py-2">{{ failedCount }} data GAGAL diupload</h3>
                    <div class="float-right py-3">
                        <b-button
                            variant="danger"
                            class="text-capitalize btn-rounded"
                            @click="downloadFailed"
                            :disabled="failedCount < 1"
                        >
                            download dan perbaiki data gagal
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="my-4">
                <b-button
                    class="text-uppercase btn-back btn-rounded"
                    :to="{ name: 'klinik-bhp-upload' }"
                >
                    kembali ke halaman upload
                </b-button>
            </div>
        </template>

        <b-card>
            <template #header>
                <div class="float-right py-3">
                    <b-button
                        variant="danger"
                        class="text-capitalize btn-rounded px-5 mr-3"
                        @click="deleteData"
                        :disabled="listBHP.length < 1"
                    >
                        hapus
                    </b-button>
                    <b-button
                        variant="primary"
                        class="text-capitalize btn-rounded px-5"
                        @click="submitData"
                        :disabled="listBHP.length < 1"
                    >
                        simpan
                    </b-button>
                </div>
            </template>

            <b-row class="py-3 row-rounded">
                <b-col md="3" class="my-1 page-select">
                    <b-form-group
                        label="Show"
                        label-for="per-page-select"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                    >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                            style="max-width:75px;"
                        ></b-form-select>
                        <label for="entries" class="pl-1">Entries</label>
                    </b-form-group>
                </b-col>
                <b-col class="text-center pl-0 align-self-end" style="margin-left: -10em">
                    <h4 class="text-uppercase font-weight-bold">preview data berhasil</h4>
                </b-col>
            </b-row>

            <b-row class="bg-alert mt-3" v-if="duplicatCount > 0">
                <b-col class="text-justify py-3 font-weight-bold f-12">
                    Terdapat <span class="text-danger">{{ duplicatCount }} buah</span> data yang sama dengan yang berada di aplikasi izidok (duplikat). Cek data bertanda bintang pada daftar dibawah ini. Anda dapat menghapus data duplikat dengan klik ‘Hapus’ atau klik ‘Simpan’ untuk memperbaharui data dengan data yang baru diunggah.
                </b-col>
            </b-row>

            <div class="table-responsive mt-4">
                <b-table
                    :fixed="true"
                    :items="listBHP"
                    :fields="fieldList"
                    :borderless="true"
                    :current-page="currentPage"
                    :per-page="perPage"
                    sticky-header="450px"
                    :tbody-tr-class="rowClass"
                >
                    <!-- slot head -->
                    <template v-slot:head()="data">
                        <div class="cell-width">
                            {{ data.label }}
                        </div>
                    </template>
                    <template v-slot:head(no)="data">
                        <b-form-checkbox
                            class="text-center"
                            style="width:50px;"
                            v-model="isCheckedAll"
                            :for="data.label"
                            :value="data.label"
                            @change="allChecked"
                        ></b-form-checkbox>
                    </template>

                    <!-- slot cell -->
                    <template v-slot:cell()="data">
                        <p class="cell-width">
                            {{ data.value }}
                        </p>
                    </template>
                    <template v-slot:cell(no)="data">
                        <b-form-checkbox
                            :name="data.item.nama_bhp"
                            v-model="checkboxBhp"
                            :value="data.item.no"
                            class="text-center"
                        ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(kode_bhp)="data">
                        <template v-if="data.item.is_duplicate">
                            <p class="cell-width">
                                {{ data.value }}**
                            </p>
                        </template>
                        <template v-else>
                            <p class="cell-width">
                                {{ data.value }}
                            </p>
                        </template>
                    </template>
                    <template v-slot:cell(harga_jual)="data">
                        <p class="text-right cell-width">
                            {{ "Rp " + data.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,") }}
                        </p>
                    </template>
                    <template v-slot:cell(stok)="data">
                        <p class="text-center cell-width">
                            {{ data.item.stok == null ? '-' : data.item.stok }}
                        </p>
                    </template>
                    <template v-slot:cell(satuan)="data">
                        <p class="text-center cell-width">
                            {{ data.item.satuan == null ? '-' : data.item.satuan }}
                        </p>
                    </template>
                    <template v-slot:cell(catatan)="data">
                        <p class="text-center cell-width">
                            {{ data.item.catatan == null ? '-' : data.item.catatan }}
                        </p>
                    </template>
                </b-table>
            </div>

            <div class="d-flex align-items-center justify-content-center">
                <span class="pl-2"
                    >Display {{ fromX }} to {{ toX }} of
                    {{ totalEntries }} entries</span
                >
                <b-pagination
                    class="mt-4 d-flex justify-content-center flex-grow-1"
                    v-model="currentPage"
                    :total-rows="totalEntries"
                    :per-page="perPage"
                    style="margin-left: -10em"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
    
    import { mapGetters } from "vuex";
    import startCase from "lodash/startCase";
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faDownload, faClock } from "@fortawesome/free-solid-svg-icons";

    library.add(faDownload, faClock);

    export default {
        data() {
            return {
                failedCount: 0,
                duplicatCount: 0,
                successCount: 0,
                currentPage: 1,
                perPage: 10,
                fromX: 0,
                toX: 0,
                totalEntries: 1,
                pageOptions: [2, 10, 25, 50, 100],
                listBHP: null,
                checkboxBhp: [],
                isCheckedAll: []
            }
        },
        beforeRouteLeave(to, from, next) {
            if (
                !this.beingSubmit
                && localStorage.getItem('IDLE') != 1
                && this.uploadBHP != null
                && to.name != 'klinik-list-bhp'
            ) {
                this.$swal({
                    title: `Anda yakin untuk keluar dari halaman ini?`,
                    text: `Pastikan Anda telah menyimpan data Anda sebelumnya!`,
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonText: startCase("tidak"),
                    confirmButtonText: startCase("ya")
                }).then(res => {
                    if (res.value) {
                        this.$store.commit("SET_UPLOAD_BHP", null);
                        next();
                    } else {
                        next(false);
                    }
                });
            } else {
                this.$store.commit("SET_UPLOAD_BHP", null);
                next();
            }
        },
        created() {
            if(this.uploadBHP == null) {
                this.$router.push('klinik-bhp-upload')
            } else {
                // length
                this.uploadBHP.success_validation.forEach(x => {
                    if(x.is_duplicate) {
                        this.duplicatCount++;
                    }
                })
                this.failedCount = this.uploadBHP.failed_validation.length - 2
                this.successCount = this.totalEntries = this.uploadBHP.success_validation.length

                // data
                this.listBHP = this.uploadBHP.success_validation

                let countBhp = this.listBHP.length;
                if(countBhp > 0) {
                  this.fromX = 1;
                  this.toX = countBhp < this.perPage ? countBhp : this.perPage; 
                }

                this.checkboxAll()
            }
        },
        computed: {
            fieldList() {
                return (
                    [
                        {
                            key: "no",
                            label: "all",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;",
                            stickyColumn: true,
                            isRowHeader: true,
                        },
                        {
                            key: "kode_bhp",
                            label: "KODE",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "kode_kfa",
                            label: "KODE KFA",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "nama_bhp",
                            label: "NAMA",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "harga_jual",
                            label: "HARGA JUAL",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "stok",
                            label: "STOK",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "satuan",
                            label: "Satuan",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "bhp_bpjs",
                            label: "BHP BPJS",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                        {
                            key: "catatan",
                            label: "Catatan",
                            thClass: "pt-4 pb-4 head-custom",
                            thStyle: "position:-webkit-sticky;position:sticky;top:0px;z-index:1;"
                        },
                    ]
                )
            },
            ...mapGetters({
                uploadBHP: "uploadBhp",
                getKlinikId: "getKlinikId"
            }),
        },
        watch: {
            checkboxBhp () {
                this.isCheckedAll = this.checkboxBhp.length == this.listBHP.length
                                    ? ['all'] : []
            },
            currentPage(val) {
              this.fromX = val * this.perPage - this.perPage + 1;
              let lastPage = val * this.perPage;
              let countBhp = this.listBHP.length;
              if(countBhp < lastPage) {
                this.toX = lastPage - this.perPage + (countBhp % this.perPage);
              }
            }
        },
        methods: {
            async submitData() {
                try {
                    let postData = []
                    this.listBHP.forEach(value => {
                        if(this.checkboxBhp.includes(value.no)) {
                            postData.push(value)
                        }
                    })

                    const res = await this.$axios.post(
                        `klinik/bhp/save-excel`, {
                            klinik_id: this.getKlinikId,
                            data: postData
                        }
                    )
                    const { status, message } = res.data

                    if(status) {
                        this.$swal({
                            text: `Data Anda telah tersimpan`,
                            type: "success",
                            allowOutsideClick: false,
                            confirmButtonText: "OK",
                        }).then(res => {
                            if (res.value) {
                                this.$store.commit("SET_UPLOAD_BHP", null);
                                this.$router.push('/klinik/bhp')
                            }
                        });
                    } else {
                        this.$swal({
                            text: message,
                            type: "error"
                        });
                    }
                } catch (err) {
                    this.$swal({
                        text: "Something went wrong",
                        type: "error"
                    });
                }
            },
            deleteData() {
                this.$swal({
                    text: `Hapus data yang telah dipilih?`,
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonText: startCase("tidak"),
                    confirmButtonText: startCase("Ya")
                }).then(res => {
                    if (res.value) {
                        // delete item
                        this.deleteChecked()
                        
                        this.$swal({
                            text: `Hapus Data Berhasil`,
                            type: "success",
                            allowOutsideClick: false,
                            confirmButtonText: "OK",
                        })
                    }
                });
            },
            async downloadFailed() {
                const res = await this.$axios.post(
                    `klinik/bhp/failed-excel`, {
                      klinik_id: this.getKlinikId,
                      data_failed: this.uploadBHP.failed_validation
                    }
                )
                const { status, data } = res.data

                if(status) {
                    window.location.href = data.link
                } else {
                    this.$swal({
                        text: "Something went wrong",
                        type: "error"
                    })
                }
            },
            checkboxAll() {
                let checked = []
                this.listBHP.forEach(x => {
                    checked.push(x.no)
                })
                
                this.checkboxBhp = [...new Set(checked)]
            },
            allChecked() {
                if(this.isCheckedAll.length > 0) {
                    this.checkboxBhp = []
                } else {
                    let checked = []
                    this.listBHP.forEach(x => {
                        checked.push(x.no)
                    })
                    this.checkboxBhp = [...new Set(checked)]
                }
            },
            rowClass(item, type) {
                if (!item || type !== 'row') return
                if (item.is_duplicate) return 'is_duplicate'
            },
            deleteChecked() {
                let newList = []
                this.listBHP.forEach(value => {
                    if(!this.checkboxBhp.includes(value.no)) {
                        newList.push(value)
                    }
                })

                this.duplicatCount = 0
                newList.forEach(x => {
                    if(x.is_duplicate) {
                        this.duplicatCount++;
                    }
                })

                let bhp  = {
                    failed_validation: this.uploadBHP.failed_validation,
                    success_validation: newList
                };

                this.$store.commit('SET_UPLOAD_BHP', bhp)

                this.listBHP = this.uploadBHP.success_validation
                this.totalEntries = this.uploadBHP.success_validation.length
            }
        },
    };
</script>

<style lang="scss">
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: #f9f9f9;
    }
    .card-bg {
        background-color : #e9e9e9
    }
    .f-9 {
        font-size: 9px;
    }
    .f-12 {
        font-size: 12px;
    }
    .f-20 {
        font-size: 20px;
    }
    .a-color {
        color: #3b3e66;
    }
    .btn-download {
        background-color: #b681fd !important;
        border-color: #b681fd !important;
        color: #ffffff !important;
        font-weight: bold;
        border-radius: 0.5em;
    }
    .btn-download:hover {
        background-color: #ac74fc !important;
        border-color: #ac74fc !important;
        color: #ffffff !important;
    }
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }
    .btn-file {
        background-color: #639bef;
        border-color: #639bef;
        color: #ffffff;
        font-weight: bold;
        font-size: 12px;
        border-radius: 0.5em;
        padding: 5px;
    }
    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .progress-bar {
        background-color: #3d8bef !important;
    }
    .modal-body {
        padding: 2.5rem 3rem 5rem 3rem !important;
    }
    .btn-rounded {
        font-weight: bold;
        font-size: 12px;
        border-radius: 0.5em;
    }
    .failed {
        background-color: #f83245;
        color: #ffffff;
        font-weight: bold;
        border-radius: 0.5em;
        padding: 10px;
    }
    .btn-back {
        background-color: #3d8bef !important;
        border-color: #3d8bef !important;
        color: #ffffff !important;
    }
    .page-select {
        font-weight: bold;
        color: #3a98db;
    }
    .row-rounded {
        border-radius: 0.5em;
        background-color : #e9e9e9
    }
    .bg-alert {
        background-color: #e6ff80;
    }
    .cell-width {
        width: 175px;;
    }
    .head-custom {
        background-color: #f4f5fd;
        color: #639bef;
        text-align: center;
        vertical-align: middle !important;
    }
    .is_duplicate {
        background-color: #c1dcf7;
    }
    @media only screen and (min-width: 1920px) {
        .min-width-content {
            min-width: 1500px !important;
        }
    }
</style>
